import React from "react";
import Img from "./Img";
import {
  getImageUrls,
  getMinioSize,
  getUpdatedImageUrlWithSize,
} from "../utils/helpers";
import ImgOptimized from "./ImgOptimized";

const MinioImg = ({
  src,
  alt,
  className,
  isLazy = false,
  isRaw = false,
  ...props
}) => {
  let modifiedSource;

  if (isRaw) {
    modifiedSource = getUpdatedImageUrlWithSize(
      `${getImageUrls([src], true)?.[0]}`,
      [3, 3, 3],
    );
  } else {
    modifiedSource = getUpdatedImageUrlWithSize(`${src}`, [1, 1, 2]);
  }
  // console.log({ modifiedSource });
  return (
    <>
      {isLazy ? (
        <Img src={modifiedSource} alt={alt} className={className} {...props} />
      ) : (
        <ImgOptimized
          alt={alt}
          className={className}
          src={modifiedSource}
          {...props}
        />
      )}
    </>
  );
};

export default MinioImg;
